const companyRoutes = {
	path: '/company',
	name: 'company',
	redirect: { name: 'companyStructure' },
	meta: { requiresAuth: true, permissions: ['settings.company.index'] },
	component: () => import('#modules/company/CompanyModule.vue'),
	children: [
		{
			path: 'structure',
			name: 'companyStructure',
			component: () => import('#modules/company/pages/StructurePage.vue'),
		},
		{
			path: 'divisions',
			name: 'divisions',
			redirect: { name: 'divisions.index' },
			children: [
				{
					path: '',
					name: 'divisions.index',
					meta: { permissions: ['settings.divisions.index'] },
					component: () => import('#modules/company/pages/DivisionIndex.vue'),
				},
				{
					path: 'create',
					name: 'divisions.create',
					meta: { permissions: ['settings.divisions.create'] },
					props: { isNew: true, isEdit: true },
					component: () => import('#modules/company/pages/DivisionPage.vue'),
				},
				{
					path: ':divisionId(\\d+)',
					name: 'divisions.show',
					meta: { permissions: ['settings.divisions.show'] },
					props: { isNew: false, isEdit: false },
					component: () => import('#modules/company/pages/DivisionPage.vue'),
				},
				{
					path: ':divisionId(\\d+)/edit',
					name: 'divisions.edit',
					meta: { permissions: ['settings.divisions.update'] },
					props: { isNew: false, isEdit: true },
					component: () => import('#modules/company/pages/DivisionPage.vue'),
				},
			],
		},
		{
			path: 'departments',
			name: 'departments',
			redirect: { name: 'departments.index' },
			children: [
				{
					path: '',
					name: 'departments.index',
					meta: { permissions: ['settings.departments.index'] },
					component: () => import('#modules/company/pages/DepartmentIndex.vue'),
				},
				{
					path: 'create',
					name: 'departments.create',
					meta: { permissions: ['settings.departments.create'] },
					props: { isNew: true, isEdit: true },
					component: () => import('#modules/company/pages/DepartmentPage.vue'),
				},
				{
					path: ':departmentId',
					name: 'departments.show',
					meta: { permissions: ['settings.departments.show'] },
					props: { isNew: false, isEdit: false },
					component: () => import('#modules/company/pages/DepartmentPage.vue'),
				},
				{
					path: ':departmentId/edit',
					name: 'departments.edit',
					meta: { permissions: ['settings.departments.update'] },
					props: { isNew: false, isEdit: true },
					component: () => import('#modules/company/pages/DepartmentPage.vue'),
				},
			],
		},
		{
			path: 'locations',
			name: 'locations',
			redirect: { name: 'locations.index' },
			children: [
				{
					path: '',
					name: 'locations.index',
					meta: { permissions: ['settings.locations.index'] },
					component: () => import('#modules/company/pages/LocationIndex.vue'),
				},
				{
					path: 'create',
					name: 'locations.create',
					meta: { permissions: ['settings.locations.create'] },
					props: { isNew: true, isEdit: true },
					component: () => import('#modules/company/pages/LocationPage.vue'),
				},
				{
					path: ':locationId',
					name: 'locations.show',
					meta: { permissions: ['settings.locations.show'] },
					props: { isNew: false, isEdit: false },
					component: () => import('#modules/company/pages/LocationPage.vue'),
				},
				{
					path: ':locationId/edit',
					name: 'locations.edit',
					meta: { permissions: ['settings.locations.update'] },
					props: { isEdit: true, isNew: false },
					component: () => import('#modules/company/pages/LocationPage.vue'),
				},
			],
		},
		{
			name: 'users',
			path: 'users',
			redirect: { name: 'users.index' },
			children: [
				{
					name: 'users.index',
					path: '',
					meta: { permissions: ['settings.users.index'] },
					component: () => import('#modules/company/pages/EmployeeIndex.vue'),
				},
				{
					path: 'create',
					name: 'users.create',
					meta: { permissions: ['settings.users.create'] },
					props: { isNew: true, isEdit: true },
					component: () => import('#modules/company/pages/EmployeePage.vue'),
				},
				{
					path: ':userId(\\d+)',
					name: 'users.show',
					meta: { permissions: ['settings.users.show'] },
					props: { isNew: false, isEdit: false },
					component: () => import('#modules/company/pages/EmployeePage.vue'),
				},
				{
					path: ':userId(\\d+)/edit',
					name: 'users.edit',
					meta: { permissions: ['settings.users.update'] },
					props: { isNew: false, isEdit: true },
					component: () => import('#modules/company/pages/EmployeePage.vue'),
				},
			],
		},
	],
}

export default companyRoutes
